export default "__VITE_ASSET__0dc11f9d__"